// Module
var code = "<template> ${display} </template> ";
// Exports
export default code;